import { SET_UBER_TOKEN } from '../constants/ActionTypes';

export default function setUberToken(uberToken) {
    return {
        type: SET_UBER_TOKEN,
        uberToken,
    };
}
